import { BASE } from '@/utils/base'
import { NFGET, NFPOST, NGET, NPOST } from '@/utils/net-work'

const baseUri = '/api'
const baseMain = BASE ? BASE : ''
// const baseMain = 'http://www.test.17zuoye.net'
// const baseMain = 'https://www.staging.17zuoye.net'

// const baseMain = ''
// 获取no publish exam
function getExamList(params) {
  return NPOST(baseUri + '/exam/list', params)
}
// 获取 exam status
function getExamStatus(params) {
  return NPOST(baseUri + '/exam/status', params)
}
// 删除
function getExamDelete(params) {
  return NPOST(baseUri + '/exam/delete', params)
}
// publish examdelete
function examDelete(params) {
  return NFPOST(baseMain + '/newexam/teacher/apply/delete.api', params)
}
// publish exam
function getOnlineList(params) {
  return NGET(baseMain + '/newexam/teacher/apply/examlist.api', params)
}
// apply revise
function applyRevise(params){
  return NFPOST(baseMain + '/newexam/teacher/apply/deleterequest.vpage', params)
}

export { getExamList, getExamStatus, getExamDelete, getOnlineList, examDelete, applyRevise }
